import { Controller } from "@hotwired/stimulus"
import { updateAvailable } from "../field_update_state"

// Connects to data-controller="field-update-banner"
// (field/shared/_update_banner.html.erb, rendered on Today and Places).
//
// Card #4859 pt 1, Scope B -- the self-serve half of the stale-tab fix.
// Scope A stops a freshly-activated service worker claiming an already-open
// tab, so a tab left open across a deploy keeps running the OLD worker (and
// the old page JS) until the tasker chooses to move on. This banner is how
// they find out there is somewhere to move on TO: it reads the one shared
// current-version state (field_update_state.js) rather than a flag of its
// own, the same state the Sync page's status card reads, so the two can
// never disagree. No polling -- field:update-available fires the instant the
// SW's message lands (see field_service_worker.js's activate handler and
// application.js's SW_UPDATED handler).
export default class extends Controller {
  static targets = ["banner"]

  connect() {
    this._render()
    this._handler = () => this._render()
    window.addEventListener("field:update-available", this._handler)
  }

  disconnect() {
    window.removeEventListener("field:update-available", this._handler)
  }

  // -- private --

  _render() {
    if (!this.hasBannerTarget) return
    const show = updateAvailable()
    this.bannerTarget.classList.toggle("hidden", !show)
    // Card #4308 taught the storage-health banner this lesson: the plain
    // HTML `hidden` attribute guards against a page rendering before its
    // stylesheet arrives (bad-connection load), where the Tailwind class
    // alone does nothing. Same guard here.
    this.bannerTarget.hidden = !show
  }
}
